export default function pxToRem(px) {
  const formatedToRem = px / 16;

  return `${formatedToRem}rem`;
}
